import axios from 'axios'

export default {
    clearAll() {
        return axios.post(
            '/api/security-users/clear-event-store',
            {},
            {
                headers: {
                    'Content-Type': 'application/ld+json'
                }
            }
        )
    }
}
